export default "__VITE_ASSET__xK9xPB0e__"